export const ROLE_PAGE_ITEMS = [
  "Dashboard",
  "Roles",
  "Users",
  "Staff",
  "Department",
  "Attendance",
  "Shift",
  "Leave Management",
  "Salary Details",
  "Holiday",
  "Doctors",
  "Treatment Charges",
  "Doctor Fee Master",
  "Patients",
  // "Yoga Patients",
  // "Homeopathy Patients",
  "Appointments",
  "Prescription Data",
  "Follow-up Rem 1",
  "Follow-up Rem 2",
  "Courtesy Call",
  // "IN Billing", // temporarily disabled
  "OUT Billing",
  "Medicine List",
  "Prescription",
  "Purchase Order",
  "Purchase List",
  "Sale Pharmacy",
  "Patient Prescription",
  "Stock Management",
  "Supplier",
  "Reports Pharmacy",
  "Lab Management",
  "Expenses",
  "Hospital Maintenance",
  "Hospital Purchases",
  "Chat",
  "Reports",
];

// Roles created/saved before the 4Health Homeopathy rebrand still have the
// old page names stored in MongoDB (e.g. "Cardiology Patients", "Fertility
// Patients"). This maps those old names to the current ones so existing
// roles keep working without needing a manual one-off DB fix.
export const RETIRED_ROLE_PAGES = new Set([
  "IN Billing",
  "Yoga Patients",
  "Homeopathy Patients",
  // Also retire the pre-rebrand names that used to map onto Yoga/Homeopathy
  // Patients, since that department feature is now removed entirely.
  "Cardiology Patients",
  "Fertility Patients",
]);

// Yoga/Homeopathy Patients department removed - this rename mapping is no
// longer needed (both the old and new names are retired above instead).
// export const PAGE_NAME_MIGRATIONS = {
//   "Cardiology Patients": "Homeopathy Patients",
//   "Fertility Patients": "Yoga Patients",
// };
export const PAGE_NAME_MIGRATIONS = {};

const defaultPriviallages = () => ({
  all: false,
  create: false,
  read: false,
  update: false,
  delete: false,
  download: false,
  mobile: false,
  address: false,
});

/**
 * Renames any stale page names found in `pages` (from the backend) to their
 * current equivalents, and adds an entry (with no access) for any page in
 * `canonicalItems` that is missing entirely - e.g. because the role was
 * created before that page existed. Returns a new array; does not mutate.
 */
export function reconcileRolePages(pages = [], canonicalItems = []) {
  const renamed = pages
    .filter((p) => !RETIRED_ROLE_PAGES.has(p.page))
    .map((p) => {
    const mappedName = PAGE_NAME_MIGRATIONS[p.page] || p.page;
    return mappedName === p.page ? p : { ...p, page: mappedName };
  });

  const existingNames = new Set(renamed.map((p) => p.page));
  const missing = canonicalItems
    .filter((name) => !existingNames.has(name))
    .map((name, i) => ({
      page: name,
      id: String(renamed.length + i + 1).padStart(3, "0"),
      access: false,
      priviallages: defaultPriviallages(),
    }));

  return [...renamed, ...missing];
}
export const isSuperAdminRole = (roleName) =>
  String(roleName || "").trim().toLowerCase() === "super admin";

export const getSuperAdminRolePages = (pages = []) => {
  const sourcePages = Array.isArray(pages) ? pages : [];
  const names = Array.from(new Set([
    ...ROLE_PAGE_ITEMS,
    ...sourcePages.map((p) => p?.page).filter(Boolean),
  ]));

  return names.map((page, index) => {
    const existing = sourcePages.find((p) => p?.page === page) || {};
    return {
      ...existing,
      page,
      id: existing.id || String(index + 1).padStart(3, "0"),
      access: true,
      priviallages: {
        ...(existing.priviallages || existing.privileges || {}),
        all: true,
        create: true,
        read: true,
        update: true,
        delete: true,
        download: true,
        ...(page === "Patients" ? { mobile: true, address: true } : {}),
      },
    };
  });
};

export const getEffectiveRolePages = (roleName, pages = []) =>
  isSuperAdminRole(roleName) ? getSuperAdminRolePages(pages) : reconcileRolePages(pages, ROLE_PAGE_ITEMS);